import type { ReactNode } from 'react';
import { BadgeWithTooltip } from '../../BadgeWithTooltip';
import { TabLayout } from '../TabLayout';
import { PlaybookActionButtons } from './PlaybookActionButtons';
import { PlaybookPageBreadcrumbs } from './PlaybookPageBreadcrumbs';
import { usePlaybookPageProps } from './PlaybookPageContext';
import { PlaybookPageTitle } from './PlaybookPageTitle';

export const PlaybookTabLayout = ({ children }: { children: ReactNode }) => {
  const { readOnly } = usePlaybookPageProps();
  return (
    <TabLayout
      entity="playbook"
      breadcrumbs={<PlaybookPageBreadcrumbs />}
      title={<PlaybookPageTitle />}
      actionButtons={<PlaybookActionButtons />}
      secondaryActionButtons={
        readOnly ? (
          <div className="flex items-center gap-1">
            <BadgeWithTooltip
              tooltipText="This asset is shared from another workspace. You can view and present it."
              badgeProps={{
                label: 'Read only',
                variant: 'primary',
              }}
            />
          </div>
        ) : null
      }
    >
      {children}
    </TabLayout>
  );
};
